// Code source from
// https://css-tricks.com/using-css-transitions-auto-dimensions/

class ReadMoreRTE {
  constructor() {
    this.createReadMore();
  }

  createReadMore() {
    // This is the important part!

    function collapseSection(element) {
      // get the height of the element's inner content, regardless of its actual size
      const sectionHeight = element.scrollHeight;

      // temporarily disable all css transitions
      const elementTransition = element.style.transition;
      element.style.transition = '';

      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we
      // aren't transitioning out of 'auto'
      requestAnimationFrame(() => {
        element.style.height = `${sectionHeight}px`;
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(() => {
          // Trim content to first paragraph height
          const elementParagraphHeight = element.querySelector('p').scrollHeight;
          element.style.height = `${elementParagraphHeight}px`;
        });
      });

      // mark the section as "currently collapsed"
      element.setAttribute('data-collapsed', 'true');
    }

    const handleTransitionEnd = (element) => {
      element.removeEventListener('transitionend', handleTransitionEnd);
      element.style.height = null;
    };

    function expandSection(element) {
      // get the height of the element's inner content, regardless of its actual size
      const sectionHeight = element.scrollHeight;

      // have the element transition to the height of its inner content
      element.style.height = `${sectionHeight}px`;

      // when the next css transition finishes (which should be the one we just triggered)
      element.addEventListener('transitionend', handleTransitionEnd(element));

      // mark the section as "currently not collapsed"
      element.setAttribute('data-collapsed', 'false');
    }

    if (!document.querySelector('.rte__read-more')) {
      return;
    }

    document.querySelector('.rte__read-more').addEventListener('click', () => {
      const section = document.querySelector('[data-collapsed]');
      const isCollapsed = (section.getAttribute('data-collapsed') === 'true');

      if (isCollapsed) {
        expandSection(section);
        section.setAttribute('data-collapsed', 'false');
      } else {
        collapseSection(section);
      }
    });

    document.addEventListener('DOMContentLoaded', () => {
      const section = document.querySelector('[data-collapsed]');
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      if (isMobile) {
        collapseSection(section);
      }
    });
  }
}

export default ReadMoreRTE;
